import { TFunction } from 'i18next';

import { Dictionary } from '#/shared/dictionaries';
import { UserStatus } from '#/shared/types';

export class UserStatusDictionary extends Dictionary<typeof UserStatus> {
  constructor(t: TFunction) {
    super(UserStatus, t, 'userStatus');
  }
}
